export const en = {
  searchPlaceholder: 'Search...',
  resultsTitle: 'Search results',
  typeToSearch: 'Search by vehicle number, agent name, policy or order reference',
  noData: "We don't have any data for the query",
  clear: 'Clear',
  close: 'Close search results',
  viewDetails: 'View Details',
  platformOrders: 'Platform Orders',
  expandSearch: 'Expand search',
};
